import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import productContext from '../context/products/ProductContext'
import { useDispatch } from 'react-redux'
import { decrement } from '../redux/slices/cartitems/index'


const CartItem = (props) => {

    const { cartitem } = props
    const context = useContext(productContext)
    const { removeitemfromcart } = context
    const dispatch = useDispatch()

    const handleRemoveitemfromcart = (id) => {
        dispatch(decrement())
        removeitemfromcart(id)
    }

    return (
        <div className="col-md-3 my-2">
            <div className="card shadow mb-5 bg-body rounded" style={{ width: "18rem" }}>
                <img src={`${cartitem.image}`} className="card-img-top" alt={`${cartitem.title}`} height='250px' />
                <div className="card-body">
                    <h5 className="card-title">{cartitem.title}</h5>
                    <p className="card-text">{cartitem.description.length > 60 ? `${cartitem.description.slice(0, 60)}...` : cartitem.title}</p>
                    <p className="card-text">Quantity : {cartitem.quantity}</p>
                    <p className="card-text">Total Price : ₹{cartitem.price}</p>
                    <Link to={`/cart`} onClick={() => handleRemoveitemfromcart(cartitem._id)} className="btn btn-primary my-1 mx-2">Remove Item from the Cart</Link>
                </div>
            </div>
        </div>
    )
}

export default CartItem

